// React
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Libraries
import Joi from "joi";
import PropTypes from "prop-types";
import { Form, Button } from "semantic-ui-react";
import { isEmpty } from "lodash";

// Redux
import { connect } from "react-redux";
import { resetPassword } from "@Actions/authentication";

// Components
import Text from "@Components/Text";
import Input from "@Components/Input";

// Utils
import { getValidationErrors } from "@Utils/functionality";

// Styles
import styles from "./styles.module.css";

const ResetPassword = ({ dispatch }) => {
	const navigate = useNavigate();
	const params = useParams();
	const defaultErrors = { password: "", confirmPassword: "" };
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [token, setToken] = useState("");
	const [errors, setErrors] = useState(defaultErrors);
	const schema = Joi.object().keys({
		password: Joi.string().min(4).required().messages({
			"string.min": "Contraseña debe tener mínimo 4 caracteres",
			"string.empty": "Contraseña es un campo requerido",
		}),
		confirmPassword: Joi.string().equal(Joi.ref("password")).min(4).required().messages({
			"string.min": "Confirmar Contraseña debe tener mínimo 4 caracteres",
			"string.empty": "Confirmar Contraseña es un campo requerido",
			"any.only": "Las contraseñas tienen que ser iguales",
		}),
	});

	useEffect(() => {
		if (params.token) {
			setToken(params.token);
		}
	}, [params]);

	const cleanupForm = () => {
		setConfirmPassword("");
		setPassword("");
		setToken("");
		setErrors(defaultErrors);
	};

	const handleInput = (e) => {
		const { value, name } = e.target;
		setErrors(defaultErrors);
		switch (name) {
			case "password":
				setPassword(value);
				break;
			case "confirmPassword":
				setConfirmPassword(value);
				break;
			default:
				break;
		}
	};

	const handleResetPassword = () => {
		const validation = schema.validate({ confirmPassword, password }, { abortEarly: false });
		if (validation.error) {
			setErrors(getValidationErrors(validation, defaultErrors));
		} else {
			dispatch(resetPassword(token, password, cleanupForm, navigate));
		}
	};

	return (
		<>
			<Text className={styles.infoTitle}>Ingrese su nueva contraseña y confirmela.</Text>
			<Form>
				<Input
					className={styles.input}
					label="Contraseña"
					isPassword
					required
					autoComplete="off"
					error={!isEmpty(errors.password) && { content: errors.password, pointing: "above" }}
					name="password"
					value={password}
					onChange={handleInput}
					onKeyPress={handleResetPassword}
				/>
				<Input
					className={styles.input}
					label="Confirmar Contraseña"
					isPassword
					required
					autoComplete="off"
					error={
						!isEmpty(errors.confirmPassword) && {
							content: errors.confirmPassword,
							pointing: "above",
						}
					}
					name="confirmPassword"
					value={confirmPassword}
					onChange={handleInput}
					onKeyPress={handleResetPassword}
				/>
			</Form>
			<Button className={styles.button} fluid onClick={handleResetPassword}>
				Reestablecer Contraseña
			</Button>
			<Text
				className={styles.titleLink}
				onClick={() => {
					return navigate("/auth/login", { replace: true });
				}}>
				Cancelar
			</Text>
		</>
	);
};

ResetPassword.propTypes = {
	dispatch: PropTypes.func,
};

export default connect()(ResetPassword);
